import { TourId } from '@/store/tourStore';
import type { LucideIcon } from 'lucide-react';
import { BookPlus, CalendarDays, Globe, LayoutGrid, Trophy } from 'lucide-react';

export { startCreateLeagueTour, TOUR_ID as CREATE_LEAGUE_TOUR_ID } from './createLeagueTour';
export { startCreateTournamentTour, TOUR_ID as CREATE_TOURNAMENT_TOUR_ID } from './createTournamentTour';
export { startPublishRegistrationTour, TOUR_ID as PUBLISH_REGISTRATION_TOUR_ID } from './publishRegistrationTour';
export { startViewSiteTour, TOUR_ID as VIEW_SITE_TOUR_ID } from './viewSiteTour';
export { startOrganizeTour, TOUR_ID as EXPLORE_COMPETITIONS_TOUR_ID } from './organizeTour';
export { injectTourStyles } from './tourConfig';

export interface TourInfo {
  id: TourId;
  name: string;
  description: string;
  /** Lucide icon component (matches the nav registry's icon language — the
      old emoji strings are gone from admin chrome). */
  icon: LucideIcon;
  startTour: (onComplete?: () => void, navigate?: (path: string) => void) => void;
}

import { startCreateLeagueTour } from './createLeagueTour';
import { startCreateTournamentTour } from './createTournamentTour';
import { startPublishRegistrationTour } from './publishRegistrationTour';
import { startViewSiteTour } from './viewSiteTour';
import { startOrganizeTour } from './organizeTour';

export const TOURS: TourInfo[] = [
  {
    id: 'create-league',
    name: 'Create Your First League',
    description: 'Learn how to set up a recurring league with divisions and teams.',
    icon: CalendarDays,
    startTour: startCreateLeagueTour,
  },
  {
    id: 'create-tournament',
    name: 'Create Your First Tournament',
    description: 'Set up a one-time tournament event with brackets and contests.',
    icon: Trophy,
    startTour: startCreateTournamentTour,
  },
  {
    id: 'publish-registration',
    name: 'Publish Registration',
    description: 'Open registration to collect team signups and payments.',
    icon: BookPlus,
    startTour: startPublishRegistrationTour,
  },
  {
    id: 'explore-competitions',
    name: 'Explore Competitions',
    description: 'Uncover the Competitions tree: expand rows, rename inline, and find every row action.',
    icon: LayoutGrid,
    startTour: startOrganizeTour,
  },
  {
    id: 'view-site',
    name: 'View Your Site Live',
    description: 'See your public league website and learn how to customize it.',
    icon: Globe,
    startTour: startViewSiteTour,
  },
];

export const getTourById = (id: TourId): TourInfo | undefined => {
  return TOURS.find(tour => tour.id === id);
};
